import { SELECTED_DATE_UPDATE } from '../../../actions/constants/types';
import globals from '../../../globals/communityGlobals';

const initialSelectedDateState = globals.now.format(globals.dateFormats.date);

function selectedDate(state = initialSelectedDateState, action) {
  switch (action.type) {
    case SELECTED_DATE_UPDATE: {
      return action.date;
    }
    default: {
      return state;
    }
  }
}

export default selectedDate;
